import { render, staticRenderFns } from "./InstrumentadorResponsavel.vue?vue&type=template&id=44a68b07&"
import script from "./InstrumentadorResponsavel.vue?vue&type=script&lang=js&"
export * from "./InstrumentadorResponsavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports